// extracted by mini-css-extract-plugin
export default {"root":"CustomerDetailPage_root__gOaJH"};